export const WEBSOCKET_URL = window.__RUNTIME_CONFIG__?.VITE_WS_URL || 'wss://paas.okonomi.cloud/cable'

// Connection states
export const CONNECTION_STATE = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
}

// ActionCable message types
export const ACTION_CABLE_COMMANDS = {
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  MESSAGE: 'message',
}

export const ACTION_CABLE_TYPES = {
  WELCOME: 'welcome',
  PING: 'ping',
  CONFIRM_SUBSCRIPTION: 'confirm_subscription',
  REJECT_SUBSCRIPTION: 'reject_subscription',
}

// Task event types
export const TASK_EVENTS = {
  CREATED: 'task.created',
  UPDATED: 'task.updated',
  COMPLETED: 'task.completed',
  FAILED: 'task.failed',
  PENDING: 'task.pending',
  RUNNING: 'task.running',
}

// Deployment event types
export const DEPLOYMENT_EVENTS = {
  CREATED: 'deployment.created',
  UPDATED: 'deployment.updated',
}

// Node event types
export const NODE_EVENTS = {
  CREATED: 'node.created',
  UPDATED: 'node.updated',
}

// Service status event types
export const SERVICE_STATUS_EVENTS = {
  CREATED: 'service_status.created',
  UPDATED: 'service_status.updated',
}

// Shell connection states
export const SHELL_CONNECTION_STATE = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  ERROR: 'error',
}

// Shell message types
export const SHELL_MESSAGE_TYPES = {
  STARTED: 'started',
  OUTPUT: 'output',
  EXIT: 'exit',
  ERROR: 'error',
}

// Reconnection settings
export const RECONNECT_DELAY_MS = 3000
export const MAX_RECONNECT_ATTEMPTS = 10
